import { connect, ConnectedProps } from 'react-redux';
import { useParams } from 'react-router-dom-v5-compat';

import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import { Backdrop } from 'dashboard/layouts/ShowViewLayoutV2';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import { ExternalIntegration } from 'dashboard/models/external-integration';
import { showMessage } from 'dashboard/redux/actions/messages';
import { RootState } from 'dashboard/redux/store';
import { loadExternalIntegration } from 'dashboard/redux/thunk-actions/external-integrations';
import useApiLoader from 'lib/hooks/useApiLoader';

type DashboardImporterDataSourceRouteProps = PropsFromRedux;

type Params = { dataSourceId: string };

const DashboardImporterDataSourceRoute = (props: DashboardImporterDataSourceRouteProps) => {
  const params = useParams<Params>() as Params; // Will always be defined

  const { loading: isExternalIntegrationLoading } = useApiLoader({
    loader: async () => {
      await props.loadExternalIntegration(params.dataSourceId);
    },
    onError: () => {
      props.showMessage('Failed to load data source, please try again', MessageType.Failure);
    },
    onNetworkError: () =>
      props.showMessage(
        'We are experiencing network issues. Please try again.',
        MessageType.Failure,
      ),
    deps: [props.loadExternalIntegration, props.showMessage],
  });

  if (isExternalIntegrationLoading) {
    return (
      <Backdrop>
        <LoadingIndicator fullscreen={true} />
      </Backdrop>
    );
  } else {
    const externalIntegration = props.externalIntegrations.find(
      (ei: ExternalIntegration) => ei.id === params.dataSourceId,
    );
    return <div>Data source: {externalIntegration?.id}</div>;
  }
};

const mapStateToProps = (state: RootState) => {
  return {
    currentEnvironment: state.currentEnvironment.currentEnvironment,
    externalIntegrations: state.externalIntegrations.externalIntegrations,
  };
};

const mapDispatchToProps = {
  loadExternalIntegration,
  showMessage,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DashboardImporterDataSourceRoute);
